import { TemplateAction } from '../../action-types';
import { VideoTemplateStateContent } from '../../types';
import {
  setCaptionsDimensions,
  setTranscription,
  updateCaptionsConfig,
} from './mutations';

export default function reducer(
  state: VideoTemplateStateContent,
  action: TemplateAction,
): VideoTemplateStateContent {
  switch (action.type) {
    case 'CAPTIONS_DIMENSIONS_CHANGE': {
      const { dimensions } = action.payload;
      return setCaptionsDimensions(state, dimensions);
    }

    case 'CAPTIONS_CONFIG_UPDATE': {
      const { captions } = action.payload;

      // TODO - refactoring fixed some type erasure.  need to fix this properly.
      return updateCaptionsConfig(state, captions as any);
    }

    case 'TRANSCRIPTION_CHANGE': {
      const { transcription } = action.payload;

      return setTranscription(state, transcription);
    }

    default:
      return state;
  }
}
